module.exports = __webpack_public_path__ + "img/avatar.f5a8ec98.png";